/**
 * 16 MB, matching the reference portal uploader's `UPLOAD_PART_SIZE_BYTES` and well above S3's 5 MB
 * minimum for a non-final part. Every payload this package uploads today (one annotated PNG) is a
 * single part; the loop is written for N because the saga is, and a floorplan scan is not small.
 */
export const UPLOAD_PART_SIZE_BYTES = 16 * 1024 * 1024;
export const UPLOAD_HASH_ALGORITHM = 'SHA-256';
function bytesToBase64(bytes) {
    let binary = '';
    for (let i = 0; i < bytes.length; i += 1) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
}
/**
 * Base64 SHA-256 via `crypto.subtle` — no `hash-wasm`, unlike the portal's uploader.
 *
 * That dependency buys an *incremental* hasher, which matters when a 4 GB camera original must be
 * hashed without ever being resident. Everything uploaded from booqly is a canvas render that is
 * already a whole Blob in memory, so the streaming variant would save nothing and cost a dependency.
 * Revisit if this package ever uploads a user-picked file.
 */
export async function sha256Base64(bytes) {
    return bytesToBase64(new Uint8Array(await crypto.subtle.digest(UPLOAD_HASH_ALGORITHM, bytes)));
}
export function planUploadParts(size) {
    const count = Math.max(1, Math.ceil(size / UPLOAD_PART_SIZE_BYTES));
    return Array.from({ length: count }, (_, index) => index + 1);
}
export function mapUploadPartUrlFromDto(dto) {
    return {
        partNumber: dto.partNumber,
        signedUrl: dto.signedUrl,
    };
}
